import React from 'react';
import { AIAssistantTool } from '../components/AIAssistantTool';
import ToolHeader from '../components/ToolHeader';

export default function AIAssistantPage() {
  return (
    <>
      <ToolHeader toolName="AI Assistant" />
      <AIAssistantTool />
    </>
  );
}
